module.exports = __webpack_public_path__ + "img/alternate_1_tablet.332da33.jpg";